import * as React from 'react';
import styled from 'styled-components';
import { colors } from '../colors/color';

import { LabelMenuItemDefinition } from './AmorgMenuTypes';
import { Label } from '../Label';

export function LabelMenuItem(props:LabelMenuItemDefinition):JSX.Element
{
    return (
        <MenuItemLabelStyle>
            <Label>{props.text}</Label>
        </MenuItemLabelStyle>);
}

const MenuItemLabelStyle = styled.div`
    padding-left: 6px;

    
    color: ${colors.text.normal};
    
`;